interface BuildMessagingCmsBannerRequestInput {
  apiUrl: string
  token: string
  workspaceId?: string
}

export function buildMessagingCmsBannerRequest({
  apiUrl,
  token,
  workspaceId
}: BuildMessagingCmsBannerRequestInput) {
  const trimmedWorkspaceId = workspaceId?.trim()

  return {
    url: `${apiUrl}/v1/messaging/cms-banners`,
    headers: { Authorization: `Bearer ${token}` },
    ...(trimmedWorkspaceId ? { params: { workspaceId: trimmedWorkspaceId } } : {})
  }
}
